import React, { JSX } from 'react'
import { PrepareSchema } from './schemas'
import { JsonLdSchema } from 'types/metadata'

// Not a React component: Next.js <Head> drops custom-component children
// (it only emits host elements). Call as a function so the returned
// <script> element is what gets handed to <Head>.
const renderLDJSON = (data: JsonLdSchema, key?: string): JSX.Element | null => {
  const html = PrepareSchema(data)
  if (!html) {
    return null
  }
  return (
    <script
      key={key}
      type='application/ld+json'
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
}

export default renderLDJSON
